<ng-progress
  #progressBar="ngProgress"
  ngProgressHttp
  ngProgressRouter
></ng-progress>
<router-outlet></router-outlet>
